module.exports = __webpack_public_path__ + "img/8400.1ed1eaa8.jpg";